module.exports = __webpack_public_path__ + "static/media/mobileresponsiveimg.3dec27d5.png";